import { Navigate } from 'react-router-dom'
import { useSessionStore } from '../hooks/use_session_store'

interface AdminRouteProps {
  children: React.ReactNode
}

export const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const session = useSessionStore()
  const isAdmin = session.user?.roles?.includes('admin')
  return isAdmin ? <>{children}</> : <Navigate to='/' />
}
